import React from "react";

const BaseModal = ({
  headerChildren,
  bodyChildren,
  onClose,
  showClose = true,
  width,
  height,
  show,
  modalStyles = {},
}) => {
  const handleClose = () => {
    if (showClose) {
      onClose();
    }
  };

  return (
    <div
      className={`z-50 fixed inset-0  flex items-center justify-center transition-opacity duration-300 ${
        show ? "opacity-100 visible" : "opacity-0 invisible"
      }`}
      onClick={handleClose}
    >
      <div
        className={`relative ${width} ${height} bg-white border-2 border-slate-200 rounded-lg shadow-xl p-5 z-50 transform transition-transform duration-300 ${
          show ? "translate-y-0 opacity-100" : "-translate-y-10 opacity-0"
        }`}
        style={modalStyles}
        onClick={(e) => e.stopPropagation()}
      >
        {headerChildren}
        {showClose && (
          <img
            src="/assets/icons/actions/x.svg"
            alt="Close"
            className="absolute top-5 right-5 cursor-pointer size-4"
            onClick={onClose}
          />
        )}
        <div className="z-50 h-[90%] mt-5">{bodyChildren}</div>
      </div>
    </div>
  );
};

export default BaseModal;
